import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import StatisticsCard from './StatisticsCard';
import bg1 from 'assets/img/icons/spot-illustrations/corner-1.png';
import bg2 from 'assets/img/icons/spot-illustrations/corner-2.png';
import bg3 from 'assets/img/icons/spot-illustrations/corner-3.png';
import bg4 from 'assets/img/icons/spot-illustrations/corner-4.png';
import bg5 from 'assets/img/icons/spot-illustrations/corner-6.png';
import bg6 from 'assets/img/icons/spot-illustrations/corner-7.png';
import bg7 from 'assets/img/icons/spot-illustrations/corner-8.png';
import bg8 from 'assets/img/icons/spot-illustrations/corner-9.png';

const StatisticsCards = ({ realEstateProjStats, realEstatePropStats }) => {
  const statsData = [
    {
      title: 'Propiedades con Mensajes sin Leer',
      value: realEstatePropStats ? realEstatePropStats.unread : 0,
      decimal: false,
      suffix: '',
      prefix: '',
      valueClassName: 'text-primary',
      image: bg4,
      link: '/propiedades',
      linkText: 'Ver Propiedades'
    },
    {
      title: 'Emprendimientos con Mensajes sin Leer',
      value: realEstateProjStats ? realEstateProjStats.unread : 0,
      decimal: false,
      suffix: '',
      prefix: '',
      valueClassName: 'text-primary',
      image: bg8,
      link: '/emprendimientos',
      linkText: 'Ver Emprendim.'
    },
    {
      title: 'Propiedades Totales',
      value: realEstatePropStats
        ? realEstatePropStats.total -
          (realEstatePropStats.finished + realEstatePropStats.deleted)
        : 0,
      decimal: false,
      suffix: '',
      prefix: '',
      valueClassName: 'text-primary',
      image: bg1,
      link: '/propiedades',
      linkText: 'Ver Propiedades'
    },
    {
      title: 'Emprendimientos Totales',
      value: realEstateProjStats
        ? realEstateProjStats.total -
          (realEstateProjStats.finished + realEstateProjStats.deleted)
        : 0,
      decimal: false,
      suffix: '',
      prefix: '',
      valueClassName: 'text-primary',
      image: bg5,
      link: '/emprendimientos',
      linkText: 'Ver Emprendim.'
    },
    {
      title: 'Propiedades Publicadas',
      value: realEstatePropStats ? realEstatePropStats.published : 0,
      decimal: false,
      suffix: '',
      prefix: '',
      valueClassName: 'text-primary',
      image: bg3,
      link: `/propiedades?filtro=published`,
      linkText: 'Ver Propiedades'
    },
    {
      title: 'Emprendimientos Publicados',
      value: realEstateProjStats ? realEstateProjStats.published : 0,
      decimal: false,
      suffix: '',
      prefix: '',
      valueClassName: 'text-primary',
      image: bg7,
      link: '/emprendimientos?filtro=published',
      linkText: 'Ver Emprendim.'
    },
    {
      title: 'Propiedades Pausadas',
      value: realEstatePropStats ? realEstatePropStats.paused : 0,
      decimal: false,
      suffix: '',
      prefix: '',
      valueClassName: 'text-primary',
      image: bg5,
      link: '/propiedades?filtro=paused',
      linkText: 'Ver Propiedades'
    },
    {
      title: 'Emprendimientos Pausados',
      value: realEstateProjStats ? realEstateProjStats.paused : 0,
      decimal: false,
      suffix: '',
      prefix: '',
      valueClassName: 'text-primary',
      image: bg5,
      link: '/emprendimientos?filtro=paused',
      linkText: 'Ver Propiedades'
    },
    {
      title: 'Propiedades Pendientes',
      value: realEstatePropStats ? realEstatePropStats.pending : 0,
      decimal: false,
      suffix: '',
      prefix: '',
      valueClassName: 'text-primary',
      image: bg2,
      link: '/propiedades?filtro=pending',
      linkText: 'Ver Propiedades'
    },
    {
      title: 'Emprendimientos Pendientes',
      value: realEstateProjStats ? realEstateProjStats.pending : 0,
      decimal: false,
      suffix: '',
      prefix: '',
      valueClassName: 'text-primary',
      image: bg6,
      link: '/emprendimientos?filtro=pending',
      linkText: 'Ver Emprendim.'
    }
  ];

  return (
    <Row className="g-3 mb-3">
      {statsData.map((stat, index) => (
        <Col
          key={stat.title}
          xs={12}
          sm={
            statsData.length % 2 === 0
              ? 6
              : index === statsData.length - 1
              ? 12
              : 6
          }
          md={
            statsData.length % 3 === 0
              ? 4
              : statsData.length % 3 === 1
              ? index === statsData.length - 1
                ? 12
                : 4
              : statsData.length % 3 === 2
              ? index === statsData.length - 1
                ? 6
                : index === statsData.length - 2
                ? 6
                : 4
              : 4
          }
          xl={
            statsData.length % 2 === 0
              ? 6
              : index === statsData.length - 1
              ? 12
              : 6
          }
        >
          <StatisticsCard stat={stat} className="h-100" />
        </Col>
      ))}
    </Row>
  );
};

StatisticsCards.propTypes = {
  realEstatePropStats: PropTypes.object,
  realEstateProjStats: PropTypes.object
};

export default StatisticsCards;
